import React from 'react';
import { Modal, Button } from 'react-bootstrap';

export const SuccessDialog = ({ show, handleClose, title, message }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{message}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="success" onClick={handleClose}>
          Volver
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
